var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('div',{staticClass:"background-mountain"},[_c('c-header',{staticClass:"reveal-from-top",attrs:{"nav-position":"right"}}),_c('main',{staticClass:"site-content entire-site"},[_vm._t("default")],2),_c('c-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }